import { Pipe, PipeTransform } from "@angular/core";
import { SchemaItem } from "../models/schema-item.interface";

@Pipe({ name: "rowData" })
export class RowDataPipe implements PipeTransform {
   public transform(rowData: any, schemaItem: SchemaItem<any>): any {
      return rowData[schemaItem.field];
   }
}
